/**
 * LineItemRow public entry point.
 * Re-exports the container to provide a stable import path.
 * @module features/contracts/components/LineItemRow
 */
export { default } from "./LineItemRowContainer";
